module.exports = __webpack_public_path__ + "media/images/lp_consultation/importance-reason01-bb7093293bba5f3cca271ccdff46d5ed.jpg";